"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorContext = void 0;
var react_1 = require("react");
var noOp = function () { };
exports.ErrorContext = (0, react_1.createContext)({
    showError: noOp
});
